<template>
  <div class="part">
    <div class="layout-page-heading">
      <div class="iconClock">
        <img src="../../assets/img/iconClock.png" alt="">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item>预约管理</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
    <div class="layout-page-box">
      <el-form :inline="true" label-width="100px" label-position="right" class="search-form">
        <el-form-item label="预约编号">
          <el-input ref="searchInput" class="modalDiaLog" v-model.trim="filters.appointmentId" clearable></el-input>
        </el-form-item>
        <el-form-item label="客户姓名">
          <el-input v-model.trim="filters.customerName" clearable></el-input>
        </el-form-item>
        <el-form-item label="操作人">
          <el-input v-model.trim="filters.doctorName" clearable></el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input v-model.trim="filters.mobile" clearable></el-input>
        </el-form-item>
        <el-form-item label="项目">
          <el-input v-model.trim="filters.projectName" clearable></el-input>
        </el-form-item>
        <el-form-item label="仪器">
          <el-input v-model.trim="filters.instrumentName" clearable></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model.trim="filters.operationStatus" clearable="" placeholder="请选择预约状态">
            <el-option v-for="(item, index) in optionsStatus" :key="index" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="初/复诊">
          <el-select v-model.trim="filters.appointStatus" clearable="" placeholder="请选择初复诊">
            <el-option v-for="(item) in typeOptions" :key="item.value" :label="item.text" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <div class="checkButton">
          <el-form-item label="预约时间">
            <el-date-picker v-model="filters.startTime" type="datetimerange" range-separator="至" start-placeholder="开始日期"
              end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="完成时间">
            <el-date-picker v-model="filters.completionStartTime" type="datetimerange" range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="query(1)">查询</el-button>
          </el-form-item>
        </div>
      </el-form>
      <div class="buttonText">
        <!-- <div class="delete" @click="del">导出数据</div> -->
        <div class="delete" @click="del">删除</div>
        <div class="addData" @click="add">新增预约</div>
        <div class="addData" @click="exportData">导出数据</div>
      </div>
    </div>

    <div class="layout-page-box">
      <el-table :data="tableData" style="width: 100%" @selection-change="handleSelectionChange" height="405"
        :header-cell-style="{ color: '#626365' }" :row-class-name="tableRowClassName">
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column prop="appointmentTime" label="预约门诊时间" width="60"></el-table-column>
        <el-table-column prop="customerName" label="客户" width="70"></el-table-column>
        <el-table-column prop="mobile" label="手机号" width="110">
          <template slot-scope="scope">
            <span v-if="areaType == 'ntbsl'">{{ scope.row.mobile.replace(/^(.{3})(?:\d+)(.{4})$/, "$1****$2") }}</span>
            <span v-else>{{ scope.row.mobile }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="appointmentId" width="120" label="预约号"></el-table-column>
        <el-table-column prop="projectName" label="项目" width="80"></el-table-column>
        <el-table-column prop="instrumentTime" label="仪器部位使用时间" width="200">
          <template slot-scope="scope">
            <el-tooltip :content="scope.row.instrumentTime" placement="top">
              <!-- el-tooltip显示内容换行插槽 -->
              <div slot="content">
                <div v-if="scope.row.instrumentTime">
                  <div v-for="(item, index) in scope.row.instrumentTime.split(',')" :key="index">
                    <span>{{ item }}</span>
                  </div>
                </div>
              </div>
              <div v-if="scope.row.instrumentTime" class="showOverTooltip">
                <div v-for="(item, index) in scope.row.instrumentTime.split(',')" :key="index">
                  <span>{{ item }}</span>
                </div>
              </div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="doctorName" label="操作人" width="80"></el-table-column>
        <el-table-column prop="appointStatus" label="初/复诊" width="60"></el-table-column>
        <el-table-column prop="userName" label="预约人" width="80"></el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="100"></el-table-column>
        <el-table-column prop="completionTime" label="完成/取消" width="100"></el-table-column>
        <el-table-column prop="operationStatus" label="状态" width="80"></el-table-column>
        <el-table-column prop="remark" label="备注" show-overflow-tooltip></el-table-column>
        <el-table-column label="操作" width="160">
          <template slot-scope="scope">
            <!-- <el-button size="mini" type="primary" @click="sureFinish(scope.$index, scope.row, 2)"
                :disabled="scope.row.operationStatus == '确认完成' || scope.row.operationStatus == '已取消' ? true : false">
                确认完成 </el-button> -->
            <el-button size="mini" type="danger" @click="sureFinish(scope.$index, scope.row, 1)"
              :disabled="scope.row.operationStatus == '确认完成' || scope.row.operationStatus == '已取消' ? true : false">取消
            </el-button>
            <el-button size="mini" type="primary" @click="handleEdit(scope.$index, scope.row)"
              :disabled="scope.row.operationStatus == '确认完成' || scope.row.operationStatus == '已取消' ? true : false">编辑
            </el-button>
            <el-button size="mini" type="warning" @click="handleCopy(scope.$index, scope.row)"
              :disabled="(scope.row.projectType == 'null' || scope.row.projectType == '' || !scope.row.projectType) ? true : false">
              复制 </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="pageChanged" :current-page="filters.pagination.page"
        :page-size="filters.pagination.limit" :page-sizes="[10, 20, 30, 50]"
        layout="total, sizes,prev, pager, next, jumper" :total="filters.pagination.total">
      </el-pagination>
    </div>
    <!-- 新增预约弹框 -->
    <el-dialog :visible.sync="dialogFormVisible" center class="dialogItem" :close-on-click-modal="false">
      <el-form :ref="formData" :model="formData" label-width="120px">
        <el-form-item label="客户姓名">
          <el-input @input="testSX" v-model.trim="formData.customerName" style="width: 90%" clearable> </el-input>
        </el-form-item>
        <el-form-item label="卡号" prop="cadCode">
          <el-input @input="testSX" v-model.trim="formData.cadCode" style="width: 90%"
            onkeyup="this.value=this.value.replace(/[^\d.]/g,'');" clearable> </el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="mobile">
          <el-input @input="testSX" v-model.trim="formData.mobile" style="width:80%"
            onkeyup="this.value=this.value.replace(/[^\d.]/g,'');" clearable> </el-input>
          <el-button class="info" type="primary" @click="getInfo" size="mini">获取信息</el-button>
        </el-form-item>
        <el-form-item label="预约门诊时间">
          <el-date-picker format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm:ss" v-model="formData.appointmentTime"
            type="datetime" placeholder="选择日期时间" style="width: 90%" :picker-options="disabledDate" @focus="datepickFocus"
            @change="datepickChange">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="项目类型">
          <el-select v-model="formData.projectType" placeholder="请选择项目类型" style="width:90%" @change="typeChange">
            <el-option v-for="item in projectTypeOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <div v-for="(item, index) in formData.AppointmentProject" :key="index" class="formIndex">
          <div class="formTitle">
            <p>预约项目{{ index + 1 }}</p>
            <span type="text" @click="deleteItems(item, index)" icon="el-icon-close" v-show="index > 0"
              class="deleteButton"><i class="el-icon-close"></i></span>
          </div>
          <el-form-item label="院区/楼层">
            <el-select @input="testSX" @change="areaChange($event, index)" v-model="item.areaCode" placeholder="请选择院区"
              style="width: 45%" :disabled="areaDisabled">
              <el-option v-for="(item, index) in areaOptions" :key="index" :label="item.areaName" :value="item.areaCode">
              </el-option>
            </el-select>
            <el-select v-model="item.floorCode" :disabled='item.disabled' placeholder="请选择楼层" style="width: 45%"
              @change="floorChange($event, index)">
              <el-option v-for="(item, index) in floorOptions" :key="index" :label="item.floorName"
                :value="item.floorCode"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="预约项目" prop="projectName">
            <el-select v-model="item.id" @change="projectChange($event, index)" @focus="projectFocusAdd($event, index)"
              :remote-method="(query) => { projectMethod(query, formData.projectType, index) }" filterable remote
              clearable placeholder="请输入搜索预约项目" style="width: 90%">
              <el-option v-for="item in projectOptions" :key="item.id" :label="item.projectName" :value="item.id"
                :disabled="item.disabled">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="宏脉项目名称" prop="hmProjectName">
            <el-input style="width: 90%" v-model="item.hmProjectName" disabled></el-input>
          </el-form-item>
          <el-form-item label="仪器" prop="instrumentName" class="instrumentName">
            <el-select v-model="item.instrumentName" placeholder="请选择" @focus="instrumentFocus($event, index)"
              @change="instrumentChange($event, index)" style="width: 90%">
              <el-option v-for="(list, index) in item.projectInstrument" :key="index" :label="list.instrumentName"
                :value="list.instrumentId">
              </el-option>
            </el-select>
          </el-form-item>
          <div v-if="item.showTime" class="appointTime">
            <el-select :class="value == '1' ? 'tips' : 'tooltips'" v-model="value">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
            <div>
              <div class="appointTimeLong" v-if="value == '0'">
                <span v-for="(list, index) in item.successAppointTime.occupied" :key="index">
                  <el-tag type="danger">{{ list.instrumentDate }}</el-tag>
                </span>
              </div>
              <div class="appointTimeLong" v-if="value == '1'">
                <span v-for="(list, index) in item.successAppointTime.unoccupied" :key="index">
                  <el-tag>{{ list.instrumentDate }}</el-tag>
                </span>
              </div>
            </div>
          </div>
          <div v-for="(domain, idx) in item.appointmentPosition " :key="idx">
            <div class="instrucPosition">
              <el-form-item :label="'部位' + (idx + 1)">
                <el-select v-model="domain.positionId" @change="positionChange($event, index, idx)"
                  @focus="positionFocus($event, index)" clearable placeholder="请输入搜索部位" style="width:45%;"
                  @input="testSX">
                  <el-option v-for="(ite, index) in item.positionOptions" :key="index"
                    :label="ite.positionName + '~' + ite.useMinute + '分钟'" :value="ite.positionId"
                    :disabled="ite.disabled">
                  </el-option>
                </el-select>
                <el-time-select v-if="item.timeFlag" @input="testSX" @change="addDateChange($event, index, idx)"
                  v-model="domain.useTime" :picker-options="{ start: '09:00', step: '00:05', end: '23:00' }"
                  placeholder="选择仪器部位使用时间" @focus="onDateFocusTime($event, index)"></el-time-select>
                <el-time-select v-if="item.dateFlag" @input="testSX" @change="addDateChange($event, index, idx)"
                  v-model="domain.useTime" :picker-options="{ start: '08:00', step: '01:00', end: '23:00' }"
                  placeholder="选择仪器部位使用时间" @focus="onDateFocusTime($event, index)"></el-time-select>

                <el-button size="mini" type="danger" @click.prevent="removeDomain(domain, idx, index)" v-show="idx > 0">
                  <i class="el-icon-delete"></i>
                </el-button>
              </el-form-item>
            </div>
          </div>
          <el-form-item style="text-align: right;margin-right:5%;">
            <el-button @click="addDomain(index)" type="primary" size="mini">新增部位</el-button>
          </el-form-item>
          <el-form-item label="操作人" prop="doctorName">
            <el-select v-model="item.doctorName" placeholder="请选择" style="width: 90%"
              @change="docotrChange($event, index)" @focus="docotrFocus($event, index)">
              <el-option v-for="(list, index) in item.projectDoctor" :key="index" :label="list.doctorName"
                :value="list.doctorId">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="初诊/复诊" prop="appointStatus">
            <el-select v-model="item.appointStatus" placeholder="请选择" style="width: 90%">
              <el-option v-for="option in typeOptions" :key="option.value" :label="option.text" :value="option.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="备注" prop="remark">
            <el-input style="width: 90%" v-model="item.remark" type="textarea" autosize></el-input>
          </el-form-item>
        </div>
        <div class="clearBottom">
          <div class="partFooter">
            <el-button type="danger" @click="closs()">取 消</el-button>
            <el-button type="primary" @click="doAddgoods()">确 定</el-button>
            <el-button type="primary" round @click="addItem">添加预约</el-button>
            <el-button type="primary" round @click="addDarft">添加至草稿箱</el-button>
          </div>
        </div>
      </el-form>
    </el-dialog>
    <!-- 编辑弹框 -->
    <editAppoint v-if="EditdialogForm" @add-comment="appendComment" ref="editAppoint" :fatherId="fatherId"
      :formData="formData" :getInfoList="getInfoList" :getList="getList" @editDialog="editDialog"></editAppoint>
    <!-- 复制弹框 -->
    <copyAppoint v-if="copyDialogForm" @add-comment="appendComment" ref="copyAppoint" :formTableLIst="formTableLIst"
      :projectInfoList="projectInfoList" :appointmentList="appointmentList" @editDialog="editDialog"></copyAppoint>
    <!-- 选择信息弹框 -->
    <el-dialog title="选择客户" append-to-body :visible.sync="dialogFormCheck" v-if="dialogFormCheck" center
      :close-on-click-modal="false">
      <info @close1="close1" :loadOptions="loadOptions" @sure="sure" :formData="formData"></info>
    </el-dialog>
  </div>
</template>

<script>
import copyAppoint from "./copyAppoint.vue";
import editAppoint from "./editAppoint.vue";
import info from "./info";
export default {
  name: "member",
  components: {
    // 复制弹框
    copyAppoint,
    //编辑弹框
    editAppoint,
    info
  },
  data() {
    var checkPhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('手机号不能为空'));
      } else if (value.length != 11) {
        return callback(new Error('手机号长度不正确'));
      } else if (isNaN(value)) {
        return callback(new Error('手机号格式不正确'));
      }
    };
    return {
      loadOptions: [],
      copyDialogForm: false,
      EditdialogForm: false,
      filters: {
        types: "",
        pagination: {
          page: 1,
          limit: 10,
          total: 0,
        },
        fatherId: '',
        startTime: "",
        endTime: "",
        appointmentId: '',
        customerName: '',
        doctorName: '',
        // createName: '',
        mobile: '',
        projectName: '',
        instrumentName: '',
        operationStatus: ''
      },
      formTableLIst: {},
      formData: {
        positionName: "",
        AppointmentProject: [{
          projectName: "",
          instrumentName: "",
          doctorName: "",
          positionName: "",
          operationStatus: "",
          projectInstrument: [],
          projectDoctor: [],
          remark: "",
          showTime: false,
          successAppointTime: '',
          appointmentPosition: [{
            positionId: '',
            useTime: '',
            positionName: '',
          }],
          dateFlag: false,
          timeFlag: true,
        },],
      },
      typeOptions: [{
        text: '初诊',
        value: 0
      },
      {
        text: '复诊',
        value: 1
      },
      {
        text: 'VIP',
        value: 2
      },
      ],
      optionsStatus: [{
        label: '待完成',
        value: 3
      },
      {
        label: '已取消',
        value: 1
      },
      {
        label: '已完成',
        value: 2
      },
      ],
      areaOptions: [{
        areaName: '伯思立',
        areaCode: 'bsl'
      }, {
        areaName: '翡立思',
        areaCode: 'fls'
      }, {
        areaName: '南通伯思立',
        areaCode: 'ntbsl'
      }],
      floorOptions: [{
        floorName: '2楼',
        floorCode: '2'
      }, {
        floorName: '3楼',
        floorCode: '3'
      },
      {
        floorName: '12楼',
        floorCode: '12'
      },
      ],
      multipleSelection: [],
      dialogFormVisible: false,
      appointmentId: "",
      tableData: [],
      projectOptions: [],
      projectData: [],
      disabled: false,
      projectInstrument: [],
      projectDoctor: [],
      arrList1: [],
      arrList2: [],
      listName3: '',
      listName4: '',
      disabledDate: {
        disabledDate: (time) => {
          return time.getTime() < new Date().getTime() - 8.64e7
        },
      },
      rules: {
        mobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
        ],
      },
      projectInfoList: [],
      getInfoList: [],
      appointmentList: {},
      getList: {},
      focusAppointTime: '',
      options: [{
        value: '0',
        label: '当日已预约时间'
      }, {
        value: '1',
        label: '当日可预约时间'
      }],
      value: '1',
      projectTypeOptions: [{
        value: '1',
        label: '皮肤'
      }, {
        value: '2',
        label: '注射'
      }, {
        value: '3',
        label: '其他'
      }],
      dateFlag: false,
      timeFlag: true,
      areaType: Lockr.get('areaType'),
      cityCode: Lockr.get('cityCode'),
      areaDisabled: true,
      dialogFormCheck: false,
    };
  },
  created() {
    if (!this.areaType || this.areaType == undefined) {
      this.areaDisabled = false
    }
  },
  methods: {
    // 获取信息
    getInfo() {
      // this.formData.customerName = ""
      if (this.formData.cadCode == '' && this.formData.mobile == '') {
        _g.toast("warning", '请填写手机号或卡号');
        return;
      }
      this.loadOption = []
      Lockr.set("selected", 1)
      this.loading = true
      let data = {
        clientCard: this.formData.cadCode,
        clientMobile: this.formData.mobile,
        clientName: this.formData.customerName,
        pageIndex: 1,
      }
      api.requestQuiet("/register/getClientInformation", data, (res) => {
        console.log(res)
        if (res.result == true) {
          this.loading = false
          if (res.data.mapList.length == 1) {
            this.formData.mobile = res.data.mapList[0].clientMobile
            this.formData.cadCode = res.data.mapList[0].clientCard
            this.formData.customerName = res.data.mapList[0].clientName
            this.$forceUpdate()
          } else {
            this.dialogFormCheck = true
            this.loadOptions = res.data.mapList
          }
        } else {
          this.loading = false
          //   获取信息之后是否可以编辑信息
          this.disabled = false
          _g.toast("warning", '请手动添加客户信息');
        }
      }, (err) => {
        this.loading = false
      });
    },
    close1() {
      this.dialogFormCheck = false
    },
    sure(obj) {
      console.log(obj);
      this.dialogFormCheck = false
      //新增和修改弹框赋值
      this.formData.customerName = obj.clientName
      this.formData.mobile = obj.clientMobile
      this.formData.cadCode = obj.clientCard
      //复制弹框赋值
      this.formTableLIst.customerName = obj.clientName
      this.formTableLIst.mobile = obj.clientMobile
      this.formTableLIst.cadCode = obj.clientCard
    },
    editDialog(arr) {
      this.dialogFormCheck = true
      this.loadOptions = arr
    },
    areaChange(val, index) {
      if (val == 'fls') {
        this.formData.AppointmentProject[index].floorCode = '1'
        this.formData.AppointmentProject[index].disabled = true
        this.floorOptions = [{
          floorName: '1楼',
          floorCode: '1'
        }]
      } else if (val == 'bsl') {
        this.formData.AppointmentProject[index].disabled = false
        this.formData.AppointmentProject[index].floorCode = ''
        this.floorOptions = [{
          floorName: '2楼',
          floorCode: '2'
        }, {
          floorName: '3楼',
          floorCode: '3'
        },
        {
          floorName: '12楼',
          floorCode: '12'
        },]
      } else if (val == 'ntbsl') {
        this.formData.AppointmentProject[index].floorCode = '1'
        this.formData.AppointmentProject[index].disabled = true
        this.floorOptions = [{
          floorName: '1楼',
          floorCode: '1'
        }]
      }
      this.formData.AppointmentProject[index].id = ''
      this.formData.AppointmentProject[index].instrumentName = ''
      this.formData.AppointmentProject[index].doctorName = ''
      this.formData.AppointmentProject[index].appointmentPosition = [{
        positionId: '',
        useTime: '',
        positionName: '',
      }]
      this.formData.AppointmentProject[index].positionOptions = []
      this.formData.AppointmentProject[index].showTime = false
    },
    testSX() {
      this.$forceUpdate()
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    pageChanged(page) {
      this.filters.pagination.page = page;
      this.refresh();
    },

    handleSizeChange(sizes) {
      this.filters.pagination.limit = sizes;
      this.refresh();
    },
    // 新增时热拉提项目两小时时间制
    addDateChange(val, index, idx) {
      val = this.formData.appointmentTime.split(' ')[0] + ' ' + val + ':00'
      if (this.formData.AppointmentProject[index].instrumentName == '') {
        _g.toast("warning", "请先选择使用仪器")
        return;
      }
      var oDate1 = new Date(this.formData.appointmentTime);
      var oDate2 = new Date(val);
      if (oDate1) {
        if (oDate1.getTime() > oDate2.getTime()) {
          _g.toast("warning", "预约仪器时间不得早于预约门诊时间");
          this.formData.AppointmentProject[index].appointmentPosition[idx].useTime = ''
          this.$forceUpdate()
          return; //第一个大
        }
      }
      this.formData.AppointmentProject[index].appointmentPosition[idx].useTime = val
      this.$forceUpdate()
    },
    instrumentFocus(val, index) {
      if (this.formData.AppointmentProject[index].projectName == '') {
        _g.toast("warning", "请先选择预约项目")
        return;
      }
    },
    // 新增时项目类型发生改变清空值
    typeChange() {
      this.formData.AppointmentProject = [{
        projectName: "",
        instrumentName: "",
        doctorName: "",
        operationStatus: "",
        appointStatus: "",
        projectInstrument: [],
        projectDoctor: [],
        remark: "",
        positionNameTime: '',
        appointmentPosition: [{
          positionId: '',
          useTime: '',
          positionName: '',
          positionNameTime: '',
        }],
        dateFlag: false,
        timeFlag: true,
        areaCode: this.areaType
      },]
      if (this.areaType == 'fls') {
        this.formData.AppointmentProject[0].floorCode = '1'
        this.formData.AppointmentProject[0].disabled = true
        this.floorOptions = [{
          floorName: '1楼',
          floorCode: '1'
        }]
      } else if (this.areaType == 'ntbsl') {
        this.formData.AppointmentProject[0].floorCode = '1'
        this.formData.AppointmentProject[0].disabled = true
        this.floorOptions = [{
          floorName: '1楼',
          floorCode: '1'
        }]
      }
    },

    instrumentChange(val, index) {
      this.arrList1 = val
      this.formData.AppointmentProject.forEach(ele => {
        if (ele.id == this.formData.AppointmentProject[index].id) {
          this.formData.AppointmentProject[index].list1 = [{
            instrumentId: this.arrList1,
          }]
          this.formData.AppointmentProject[index].projectInstrument.forEach(item => {
            if (item.instrumentId == val) {
              this.formData.AppointmentProject[index].listName4 = item.instrumentName
            }
          });
        }
        this.formData.AppointmentProject[index].appointmentPosition = [{
          positionId: '',
          useTime: '',
          positionName: '',
        }]
        // 根据预约门诊时间和仪器id提示仪器已预约时间
        let queryData = {
          appointmentTime: this.formData.appointmentTime,
          instrumentId: this.arrList1,
        }
        api.request("/appointment/findInstrumentDateById", queryData, (res) => {
          if (res.result == true) {
            let dataTimeAppoint = res.data
            console.log(dataTimeAppoint)
            if (dataTimeAppoint.unoccupied) {
              this.formData.AppointmentProject[index].showTime = true
              this.formData.AppointmentProject[index].successAppointTime = dataTimeAppoint
            } else if (!dataTimeAppoint.unoccupied) {
              this.formData.AppointmentProject[index].showTime = false
            }
          }
          this.$forceUpdate()
        }, (err) => { });
        this.formData.AppointmentProject[index].list2 = ''
        this.formData.AppointmentProject[index].doctorName = ''
        console.log(this.formData.AppointmentProject[index])
      });
      this.$forceUpdate()
    },
    onDateFocusTime(val, index) {
      this.formData.AppointmentProject[index].doctorName = ''
      this.formData.AppointmentProject[index].listName3 = ''
      if (this.formData.AppointmentProject[index].instrumentName == '') {
        _g.toast("warning", "请先选择使用仪器")
        return;
      }
    },
    docotrChange(val, index) {
      this.arrList2 = val
      this.formData.AppointmentProject.forEach(ele => {
        if (ele.id == this.formData.AppointmentProject[index].id) {
          this.formData.AppointmentProject[index].list2 = [{
            doctorId: this.arrList2
          }]
          this.formData.AppointmentProject[index].projectDoctor.forEach(item => {
            if (item.doctorId == val) {
              this.formData.AppointmentProject[index].listName3 = item.doctorName
            }
          });
        }
      });
    },


    refresh() {
      router.push({
        path: this.$route.path,
        query: _.merge({},
          this.$route.query, {
          __query: JSON.stringify(this.pagination),
        }, {
          random: Math.random(),
        }
        ),
      });
    },
    // 新增项目
    add() {
      this.dialogFormVisible = true;
      // 新增置空
      this.formData = {
        positionName: "",
        AppointmentProject: [{
          projectName: "",
          instrumentName: "",
          doctorName: "",
          positionName: "",
          areaCode: this.areaType,
          operationStatus: '',
          projectInstrument: [],
          projectDoctor: [],
          remark: "",
          appointmentPosition: [{
            positionId: '',
            useTime: '',
            positionName: '',

          }],
          timeFlag: true,
          dateFlag: false,
        },],
        showTime: false,
        successAppointTime: '',
      };
      this.appointmentId = "";
      this.projectOptions = ''
      if (this.areaType == 'fls') {
        this.formData.AppointmentProject[0].floorCode = '1'
        this.formData.AppointmentProject[0].disabled = true
        this.floorOptions = [{
          floorName: '1楼',
          floorCode: '1'
        }]
      } else if (this.areaType == 'ntbsl') {
        this.formData.AppointmentProject[0].floorCode = '1'
        this.formData.AppointmentProject[0].disabled = true
        this.floorOptions = [{
          floorName: '1楼',
          floorCode: '1'
        }]
      }
    },
    // 删除项目
    del() {
      var data = this.multipleSelection;
      var id = [];
      data.map(function (item, index) {
        console.log(item)
        id.push(item.appointmentId);
      });
      this.$confirm("确定要删除选中的数据吗？", "删除项目", {
        center: true,
      })
        .then((res) => {
          api.requestQuiet(
            "/appointment/deleteAppiontmentByIds", {
            ids: id.toString(),
          },
            (res) => {
              if (res.result == true) {
                _g.toast("success", "删除成功");
                this.query(this.filters.pagination.page);
              } else {
                _g.toast("error", "删除失败");
                this.query(this.filters.pagination.page);
              }
            }, (err) => { }
          );
        })
        .catch((err) => {
          // this.$message.error('删除失败！');
        });
    },
    closs() {
      this.dialogFormVisible = false;
    },

    // 确定新增
    doAddgoods() {
      console.log('选择完部位之后的总数据this.formData.AppointmentProject[index]')
      console.log(this.formData)
      console.log(this.formData.AppointmentProject)
      if (!this.formData.customerName || this.formData.customerName == '') {
        _g.toast("warning", "请填写顾客名称")
        return;
      }
      if (!this.formData.mobile || this.formData.mobile == '') {
        _g.toast("warning", "请填写电话号码")
        return;
      }
      if (!this.formData.appointmentTime || this.formData.appointmentTime == '') {
        _g.toast("warning", "请填写预约时间")
        return;
      }
      let empId = Lockr.get("empId");
      this.formData.userId = empId
      let data = JSON.parse(JSON.stringify(this.formData))
      if (data.AppointmentProject) {
        data.AppointmentProject.forEach(ele => {
          ele.projectInstrument = ele.list1
          ele.projectDoctor = ele.list2
          ele.doctorName = ele.listName3
          ele.instrumentName = ele.listName4
          ele.projectId = ele.id
        });
      }
      // 添加院区以及楼层参数名
      this.areaOptions.forEach(ele => {
        data.AppointmentProject.forEach(item => {
          if (item.areaCode == ele.areaCode) {
            item.areaName = ele.areaName
          }
        });
      });
      this.floorOptions.forEach(ele => {
        data.AppointmentProject.forEach(item => {
          if (item.floorCode == ele.floorCode) {
            item.floorName = ele.floorName
          }
        });
      });
      if (this.areaType && this.areaType != undefined) {
        data.areaType = this.areaType
        data.areaCode = this.areaType
      } else {
        data.areaType = data.AppointmentProject[0].areaCode
        data.areaCode = data.AppointmentProject[0].areaCode
      }
      console.log(this.formData)
      console.log(data.AppointmentProject)
      // 重复预约识别
      let projectIdList = []
      data.AppointmentProject.forEach(ele => {
        projectIdList.push(ele.projectId)
        console.log(projectIdList.toString())
      });
      let sureData = {
        mobile: this.formData.mobile,
        customerName: this.formData.customerName,
        projectId: projectIdList.toString(), // 项目id集合
        appointmentId: '', // 修改时必传
        status: 1, // 1：新增 2：修改
        appointmentTime: this.formData.appointmentTime.split(' ')[0]
      }
      if (sureData.projectId == '') {
        _g.toast("warning", "请填写完整项目")
        return;
      }
      var that = this
      api.requestQuiet("/appointment/findDistinguishData", sureData, (res) => {
        console.log(res.data)
        if (res.data != 0) {
          this.$confirm("该客户在当前时间已预约过此项目,是否确定要重复预约？", {
            center: true,
          }).then((res) => {
            that.insertOrUpdateList(data)
          }).catch((err) => {
            // this.$message.error('删除失败！');
          });
        } else if (res.data == 0) {
          that.insertOrUpdateList(data)
        }
      }, (err) => { });
    },
    // 新增项目接口封装
    insertOrUpdateList(data) {
      api.requestQuiet("/appointment/insertOrUpdateAppointment", data, (res) => {
        if (res.result == true) {
          this.dialogFormVisible = false;
          if (res.data != '') {
            _g.toast("success", res.data);
          }
          this.query(this.filters.pagination.page);
        } else {
          _g.toast("error", res.errMsg);
          this.query(this.filters.pagination.page);
        }
      }, (err) => { });
    },
    handleEdit(index, row) {
      this.formData = {}
      this.EditdialogForm = true;
      this.$nextTick(() => {
        this.$refs.editAppoint.openDialog1Visible();
      });
      this.fatherId = row.appointmentId;
      let data = {
        appointmentId: row.appointmentId
      }
      // 预约回显
      api.request("/appointment/findAppiontmentById", data, (res) => {
        // console.log(res.data.appointmentInfo)
        this.getInfoList = JSON.parse(JSON.stringify(res.data.projectInfo));
        this.getInfoList.projectDoctor.push({
          doctorId: '999999',
          doctorName: '无指定操作人'
        })
        this.getInfoList.projectDoctor.forEach(ele => {
          ele.doctorId = ele.doctorId.toString()
        });
        if (this.formData.instrumentDate) {
          this.formData.instrumentDate = this.formData.instrumentUsetime
        }
        this.formData = JSON.parse(JSON.stringify(res.data.appointmentInfo));
        this.getList = JSON.parse(JSON.stringify(res.data.appointmentPosition));
      }, (err) => { });
    },
    // 复制信息
    handleCopy(index, row) {
      this.formTableLIst = {}
      this.copyDialogForm = true;
      this.$nextTick(() => {
        this.$refs.copyAppoint.openDialog1Visible();
      });
      let data = {
        appointmentId: row.appointmentId
      }
      // 预约回显
      api.request("/appointment/findAppiontmentById", data, (res) => {
        this.projectInfoList = JSON.parse(JSON.stringify(res.data.projectInfo));
        this.projectInfoList.projectDoctor.push({
          doctorId: '999999',
          doctorName: '无指定操作人'
        })
        this.projectInfoList.projectDoctor.forEach(ele => {
          ele.doctorId = ele.doctorId.toString()
        });
        if (this.formTableLIst.instrumentDate) {
          this.formTableLIst.instrumentDate = this.formTableLIst.instrumentUsetime
        }
        this.formTableLIst = JSON.parse(JSON.stringify(res.data.appointmentInfo));
        this.appointmentList = JSON.parse(JSON.stringify(res.data.appointmentPosition));
      }, (err) => { });
    },
    // 新增时筛选操作人
    docotrFocus(val, index) {
      console.log(this.formData.AppointmentProject[index])
      if (!this.formData.AppointmentProject[index].appointmentPosition[0].useTime) {
        _g.toast("warning", "请先选择仪器预约时间");
        return;
      }
      // 根据选择仪器时间筛选操作人
      let arrForm = []
      this.formData.AppointmentProject[index].projectDoctorFilter.forEach(ele => {
        arrForm.push(ele.doctorId)
      });
      let queryData = {
        appointmentTime: this.formData.appointmentTime,
        doctorIds: arrForm,
        instrumentId: this.formData.AppointmentProject[index].list1[0].instrumentId,
        appointmentPosition: this.formData.AppointmentProject[index].appointmentPosition
      }
      api.request("/appointment/findDoctorByInstrumentDate", queryData, (res) => {
        if (res.result == true) {
          let resData = res.data
          // 筛选id相同的医生数据
          if (resData.length != 0) {
            let add = this.formData.AppointmentProject[index].projectDoctorFilter.filter(item => resData.some(ele =>
              ele.doctorId === item.doctorId))
            add.push({
              doctorId: '999999',
              doctorName: '无指定操作人'
            })
            this.formData.AppointmentProject[index].projectDoctor = add
          } else if (resData.length == 0) {
            this.formData.AppointmentProject[index].projectDoctor = [{
              doctorId: '999999',
              doctorName: '无指定操作人'
            }]
          }
        }
      }, (err) => { });
    },
    // 查询数据列表
    query(page) {
      // console.log(this.filters.completionStartTime)
      let empId = Lockr.get("empId");
      let clientType = Lockr.get("clientType");
      // console.log(clientType)
      // console.log(empId)
      var querys = {
        appointmentId: this.filters.appointmentId,
        customerName: this.filters.customerName,
        doctorName: this.filters.doctorName,
        // createName: this.filters.createName,
        mobile: this.filters.mobile,
        projectName: this.filters.projectName,
        instrumentName: this.filters.instrumentName,
        operationStatus: this.filters.operationStatus,
        appointStatus: this.filters.appointStatus,
        completionStartTime: "",
        completionEndTime: "",
        startTime: "",
        endTime: "",
        page: page,
        size: this.filters.pagination.limit,
        clientType: clientType,
        areaType: this.areaType,
        areaCode: this.areaType
      };
      if (clientType == '1') {
        querys.userId = empId
      }
      if (this.filters.startTime) {
        querys.startTime = this.filters.startTime[0];
        querys.endTime = this.filters.startTime[1];
      }
      if (this.filters.completionStartTime) {
        querys.completionStartTime = this.filters.completionStartTime[0];
        querys.completionEndTime = this.filters.completionStartTime[1];
      }
      // console.log(querys)
      api.requestQuiet("/appointment/findAppointmentPage", querys, (res) => {
        // console.log(res)
        var data = res.data.list;
        this.tableData = data
        this.orgData = data;
        this.filters.pagination.total = parseInt(res.data.total);
      }, (err) => { });
    },
    // 搜索查询全部可预约项目
    projectMethod(val, projectType, index) {
      let querys = {
        projectName: val,
        projectType: projectType,
        areaCode: this.formData.AppointmentProject[index].areaCode,
        cityCode: this.cityCode
      };
      api.request("/project/findProjectListByName", querys, (res) => {
        // console.log(res)
        if (res.data.length == 0) {
          _g.toast("warning", "还没有可选择的项目!");
        }
        this.projectOptions = res.data;
        this.formData.AppointmentProject.map((x, i) => {
          this.projectOptions.map((s) => {
            if (x.id === s.id) {
              s.disabled = true
            }
          })
        })
        this.$forceUpdate()
      }, (err) => { });
    },

    // 新增弹框查询项目
    projectFocusAdd(val, index) {
      // 查询项目之前先判断预约门诊时间是否填写
      if (this.formData.appointmentTime == '' || this.formData.appointmentTime == undefined) {
        _g.toast("warning", "请先选择预约门诊时间");
        return;
      }
      if (this.formData.projectType == '' || this.formData.projectType == undefined) {
        _g.toast("warning", "请先选择项目类型");
        return;
      }
      if (this.formData.AppointmentProject[index].areaCode == '' || this.formData.AppointmentProject[index].areaCode ==
        undefined) {
        _g.toast("warning", "请先选择院区");
        return;
      }
      if (this.formData.AppointmentProject[index].floorCode == '' || this.formData.AppointmentProject[index].floorCode ==
        undefined) {
        _g.toast("warning", "请先选择楼层");
        return;
      }
      let querys = {
        projectName: "",
        projectType: this.formData.projectType,
        areaCode: this.formData.AppointmentProject[index].areaCode,
        cityCode: this.cityCode
      };
      api.request("/project/findProjectListByName", querys, (res) => {
        if (res.data.length == 0) {
          _g.toast("warning", "还没有可选择的项目!");
          this.$forceUpdate()
        }
        this.projectOptions = res.data;
        this.formData.AppointmentProject.map((x, i) => {
          this.projectOptions.map((s) => {
            if (x.id === s.id) {
              s.disabled = true
            }
          })
        })
        this.$forceUpdate()

      }, (err) => { });
      this.formData.AppointmentProject[index].instrumentName = ''
      this.formData.AppointmentProject[index].doctorName = ''
      this.formData.AppointmentProject[index].appointmentPosition = [{
        positionId: '',
        useTime: '',
        positionName: '',
      }]
      this.formData.AppointmentProject[index].positionOptions = []
      this.formData.AppointmentProject[index].showTime = false
      this.formData.AppointmentProject[index].successAppointTime = []
    },
    // 新增时楼层改变的操作
    floorChange(val, index) {
      console.log(val, index)
      this.formData.AppointmentProject[index].id = ''
      this.formData.AppointmentProject[index].instrumentName = ''
      this.formData.AppointmentProject[index].doctorName = ''
      this.formData.AppointmentProject[index].appointmentPosition = [{
        positionId: '',
        useTime: '',
        positionName: '',
      }]
      this.formData.AppointmentProject[index].positionOptions = []
    },
    // 新增操作根据选中的项目id查询可用仪器操作人等
    projectChange(val, index) {
      // console.log(val, index)
      let querys = {
        id: val,
        areaCode: this.formData.AppointmentProject[index].areaCode,
        floorCode: this.formData.AppointmentProject[index].floorCode,
        areaType: this.areaType
      };
      api.request("/project/findProjectBydId", querys, (res) => {
        // console.log(res.data)
        this.projectData = res.data
        // 新增时部位回显
        if (this.formData.AppointmentProject) {
          this.formData.AppointmentProject.forEach(ele => {
            if (ele.id == this.projectData.id) {
              ele.projectInstrument = this.projectData.projectInstrument
              ele.projectDoctorFilter = this.projectData.projectDoctor
              ele.positionName = this.projectData.positionName
              ele.positionId = this.projectData.positionId
              ele.projectName = this.projectData.projectName
              ele.hmProjectName = this.projectData.hmProjectName
              ele.operationStatus = 3
            }
          });
        }
        // 项目时间两小时制分类
        let ss = this.projectData.projectName.includes('热拉提')
        let vv = this.projectData.projectName.includes('热玛吉')
        this.formData.AppointmentProject[index].dateFlag = false
        this.formData.AppointmentProject[index].timeFlag = true
        if (ss == true || vv == true) {
          this.formData.AppointmentProject[index].dateFlag = true
          this.formData.AppointmentProject[index].timeFlag = false
        } else {
          this.formData.AppointmentProject[index].dateFlag = false
          this.formData.AppointmentProject[index].timeFlag = true
        }
      }, (err) => { });


    },

    /*动态新增表单项*/
    addItem() {
      this.formData.AppointmentProject.push({
        areaCode: this.areaType,
        projectName: "",
        instrumentName: "",
        doctorName: "",
        positionName: "",
        key: Date.now(),
        projectInstrument: [],
        projectDoctor: [],
        operationStatus: "",
        remark: "",
        showTime: false,
        successAppointTime: '',
        appointmentPosition: [{
          positionId: '',
          useTime: '',
          positionName: '',
        }],
      });
      if (this.areaType == 'fls') {
        this.formData.AppointmentProject.forEach(item => {
          item.floorCode = '1'
          item.disabled = true
        });
        this.floorOptions = [{
          floorName: '1楼',
          floorCode: '1'
        }]
      }
    },
    /*删除新增的表单项*/
    deleteItems(item, index) {
      this.index = this.formData.AppointmentProject.indexOf(item);
      if (index !== -1) {
        this.formData.AppointmentProject.splice(index, 1);
      }
    },
    // 更改预约状态
    sureFinish(index, row, val) {
      // 2-确认完成,1-取消
      console.log(val)
      let data = {
        appointmentId: row.appointmentId,
        operationStatus: val
      }
      this.$confirm("确定要更改预约状态吗？", "更改预约状态", {
        center: true,
      })
        .then((res) => {
          api.request("/appointment/updateAppointmentStatusById", data, (res) => {
            if (res.result == true) {
              _g.toast("success", "状态修改成功");
              this.query(this.filters.pagination.page);
            } else {
              _g.toast("error", "状态修改失败");
              this.query(this.filters.pagination.page);
            }
          }, (err) => { });
        })
        .catch((err) => {
          // this.$message.error('删除失败！');
        });

    },
    CompareDate(t1, t2) {
      var date = new Date();
      console.log(date)
      var a = t1.split(":");
      var b = t2.split(":");
      return date.setHours(a[0], a[1]) > date.setHours(b[0], b[1]);
    },
    datepickFocus() {
      if (this.formData.appointmentTime || this.formData.appointmentTime != undefined) {
        this.focusAppointTime = this.formData.appointmentTime
      }
    },
    // 预约门诊时间更改之后修改内容
    datepickChange(val) {
      var ee = this.formData.appointmentTime.split(' ')[1]
      var ff = '08:59:59'
      if (this.CompareDate(ee, ff) == false) {
        this.formData.appointmentTime = ''
        _g.toast("warning", "请选择九点之后的时间");
        return;
      }
      this.formData.AppointmentProject.forEach(item => {
        console.log(item)
        item.doctorName = ''
        item.list2 = []
        if (this.arrList1.length != 0) {
          console.log('this.focusAppointTime')
          console.log(this.focusAppointTime)
          let year1 = this.focusAppointTime.split('-')[0]
          let year2 = val.split('-')[0]
          let month1 = this.focusAppointTime.split('-')[1]
          let month2 = val.split('-')[1]
          if (this.focusAppointTime != '') {
            var day1 = this.focusAppointTime.split('-')[2].substring(0, 2)
          }
          let day2 = val.split('-')[2].substring(0, 2)
          if (year1 == year2 && month1 == month2 && day1 == day2) {
            console.log('新增预约同一天')
          } else {
            console.log('新增预约更改日期')
            console.log(item)
            // 修改预约门诊时间时直接修改预约仪器部位时间
            var aa = item.appointmentPosition[0].useTime.search("undefined") != -1
            if (item.appointmentPosition[0].useTime != '' || aa == true) {
              item.appointmentPosition.forEach((ele, idx) => {
                let aa = ele.useTime.split(' ')[1]
                let bb = val.split(' ')[0]
                ele.useTime = bb + ' ' + aa
              });
            }
            // 根据预约门诊时间和仪器id提示仪器已预约时间
            let queryData = {
              appointmentTime: this.formData.appointmentTime,
              instrumentId: item.list1[0].instrumentId,
            }
            api.request("/appointment/findInstrumentDateById", queryData, (res) => {
              if (res.result == true) {
                let dataTimeAppoint = res.data
                if (dataTimeAppoint.unoccupied) {
                  item.showTime = true
                  item.successAppointTime = dataTimeAppoint
                } else if (!dataTimeAppoint.unoccupied) {
                  item.showTime = false
                }
              }
              this.$forceUpdate()
            }, (err) => { });
            this.$forceUpdate()
          }
        }
      });
    },
    // 表格不同行设置不同的样式
    tableRowClassName({
      row,
      rowIndex
    }) {
      if (row.operationStatus == '待完成' && row.appointStatus == '初诊') {
        return 'warningRed';
      } else if (row.operationStatus == '待完成' && row.appointStatus == 'VIP') {
        return 'warningBlue';
      }
      return '';
    },
    removeDomain(item, idx, listIndex) {
      var index = this.formData.AppointmentProject[listIndex].appointmentPosition.indexOf(item)
      if (index !== -1) {
        this.formData.AppointmentProject[listIndex].appointmentPosition.splice(idx, 1)
      }
    },
    positionFocus(val, index) {
      console.log(this.formData.AppointmentProject[index])
      if (this.formData.AppointmentProject[index].instrumentName == '') {
        _g.toast("warning", "请先选择仪器");
        return;
      }
      api.request("/instrument/findInstrumentById", {
        instrumentId: this.formData.AppointmentProject[index].list1[0].instrumentId
      }, (res) => {
        this.$nextTick(() => {
          this.formData.AppointmentProject[index].positionOptions = res.data.InstrumentPosition
          this.formData.AppointmentProject[index].positionOptions.map((x, i) => {
            this.formData.AppointmentProject[index].appointmentPosition.map((s) => {
              if (x.positionId === s.positionId) {
                x.disabled = true
              }
            })
          })
          this.$forceUpdate()
        });
      }, (err) => { })
    },
    positionChange(val, index, idx) {
      this.formData.AppointmentProject[index].appointmentPosition[idx].positionId = val
      this.formData.AppointmentProject[index].positionOptions.forEach(ele => {
        if (val == ele.positionId) {
          this.formData.AppointmentProject[index].appointmentPosition[idx].positionName = ele.positionName
        }
      });
      api.request("/instrument/findInstrumentById", {
        instrumentId: this.arrList1
      }, (res) => {
        this.$nextTick(() => {
          this.formData.AppointmentProject[index].positionOptions = res.data.InstrumentPosition
          this.formData.AppointmentProject[index].positionOptions.map((x, i) => {
            this.formData.AppointmentProject[index].appointmentPosition.map((s) => {
              if (x.positionId === s.positionId) {
                x.disabled = true
              }
            })
          })
          this.$forceUpdate()
        });
      }, (err) => { })
    },
    addDomain(index) {
      this.formData.AppointmentProject[index].appointmentPosition.push({
        positionId: '',
        positionName: '',
        useTime: '',
        key: Date.now(),
      });
    },


    appendComment(item) {
      this.query(this.filters.pagination.page);
    },
    // 导出数据
    exportData() {
      let exportUrl = axios.defaults.baseURL;
      var formData = new FormData();
      formData.append("appointmentId", this.filters.appointmentId)
      formData.append("customerName", this.filters.customerName)
      formData.append("doctorName", this.filters.doctorName)
      // formData.append("createName", this.filters.createName)
      formData.append("mobile", this.filters.mobile)
      formData.append("projectName", this.filters.projectName)
      formData.append("instrumentName", this.filters.instrumentName)
      formData.append("operationStatus", this.filters.operationStatus)
      formData.append("page", this.filters.pagination.page)
      formData.append("size", this.filters.pagination.limit)
      formData.append("appointStatus", this.filters.appointStatus)
      if (this.areaType) {
        formData.append("areaCode", this.areaType)
      } else if (!this.areaType) {
        formData.append("areaCode", '')
      }
      if (this.filters.startTime) {
        formData.append("startTime", this.filters.startTime[0])
        formData.append("endTime", this.filters.startTime[1])
      }
      if (this.filters.completionStartTime) {
        formData.append("completionStartTime", this.filters.completionStartTime[0])
        formData.append("completionEndTime", this.filters.completionStartTime[1])
      }
      this.$confirm("此操作将导出excel文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.loading = true;
          axios
            .post(
              exportUrl + "appointment/toExcelAppointmentSchedule", formData, {
              responseType: "blob",
            }
            )
            .then((res) => {
              console.log(res)
              const blob = new Blob([res.data], {
                type: "application/vnd.ms-excel",
              });
              // console.log(blob, '----------0990');
              const fileName = "预约数据.xlsx";
              const linkNode = document.createElement("a");
              linkNode.download = fileName; //a标签的download属性规定下载文件的名称
              linkNode.style.display = "none";
              linkNode.href = URL.createObjectURL(blob); //生成一个Blob URL
              document.body.appendChild(linkNode);
              linkNode.click(); //模拟在按钮上的一次鼠标单击
              URL.revokeObjectURL(linkNode.href); // 释放URL 对象
              document.body.removeChild(linkNode);
              this.loading = false;
            });
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 添加至草稿箱
    addDarft() {
      if (!this.formData.customerName || this.formData.customerName == "") {
        _g.toast("warning", "请填写顾客名称");
        return;
      }
      if (!this.formData.mobile || this.formData.mobile == "") {
        _g.toast("warning", "请填写电话号码");
        return;
      }
      if (!this.formData.appointmentTime || this.formData.appointmentTime == "") {
        _g.toast("warning", "请填写预约时间");
        return;
      }
      let empId = Lockr.get("empId")
      this.formData.userId = empId
      let data = JSON.parse(JSON.stringify(this.formData))
      if (data.AppointmentProject) {
        data.AppointmentProject.forEach(ele => {
          console.log(ele)
          if (ele.list1) {
            ele.projectInstrument = ele.list1
          } else {
            ele.projectInstrument = []
          }
          if (ele.list2) {
            ele.projectDoctor = ele.list2
          } else {
            ele.projectDoctor = []
          }
          if (ele.listName3) {
            ele.doctorName = ele.listName3
          } else {
            ele.doctorName = ''
          }
          if (ele.listName4) {
            ele.instrumentName = ele.listName4
          } else {
            ele.instrumentName = ''
          }
        });
      }
      console.log(data)
      data.areaType = this.areaType
      data.areaCode = this.areaType
      api.request("/appointment/saveAppointmentDrafts", data, (res) => {
        this.$nextTick(() => {
          _g.toast("success", "草稿箱添加成功！");
          this.dialogFormVisible = false
          this.$forceUpdate()
        });
      }, (err) => { })
    }
  },
  mounted() {
    /*this.init();*/
    this.query(this.filters.pagination.page);
  },
  watch: {
    $route(to, from) {
      this.query(this.filters.pagination.page);
    },
  },
};
</script>
<style>
.el-tooltip__popper[x-placement^="top"] {
  width: 150px !important;
}
</style>

<style scoped>
@import "../../assets/css/main.css";

.part>>>.el-dialog--center .el-dialog__body {
  text-align: center;
  margin-bottom: 25px !important;
  padding-bottom: 0 !important;
  box-sizing: border-box;
}

.dialogItem>>>.el-input__inner {
  height: 34px;
  background: #ffffff;
  /* box-shadow: 0px 0px 5px 3px #caeafd; */
  border-radius: 3px;
  /* border: 1px solid #23a2ee; */
}

.dialogItem>>>.el-form-item__label {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #626365;
  width: 96px;
}

.clearBottom>>>.el-form-item {
  margin-bottom: 0 !important;
}

.partFooter>>>.el-button--primary {
  width: 125px;
  height: 34px;
  background: #5a7ef8;
  border-radius: 17px;
  line-height: 5px;
}

.checkButton>>>.el-button--primary {
  width: 98px;
  height: 34px;
  background: #5a7ef8;
  border-radius: 17px;
  line-height: 5px;
}

.partFooter>>>.el-button--danger {
  width: 125px;
  height: 34px;
  border-radius: 17px;
  border: 1px solid #5a7ef8;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #5a7ef8;
  line-height: 2px;
  background: none;
}

.pageInput>>>.el-input__inner {
  /* width: 400px; */
  /* height: 38px; */
  /* background: #f6f7fb; */
  border-radius: 23px;
  /* border: none; */
}

.appointTimeLong>>>.el-tag {
  margin-bottom: 10px;
  margin-right: 10px;
}

.el-table>>>.warningRed {
  color: #f56c6c;
}

.el-table>>>.warningBlue {
  color: #1b84ed;
}

.dialogItem>>>.el-form-item__error {
  left: 30px !important;
}

.tips>>>.el-input__inner {
  background-color: #ecf5ff;
  border-color: #d9ecff;
  color: #409eff;
  width: 155px;
}

.tooltips>>>.el-input__inner {
  background-color: #fef0f0;
  border-color: #fde2e2;
  color: #f56c6c;
  width: 155px;
}

.instrucPosition>>>.el-button i {
  margin: 0 !important;
}

.tips>>>.el-icon-arrow-up:before {
  color: #409eff;
}

.tooltips>>>.el-icon-arrow-up:before {
  color: #f56c6c;
}
</style>